import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable,BehaviorSubject } from 'rxjs';
import { environment } from './../../environments/environment';
import { HttpHeaders } from '@angular/common/http';
import { ConstantsService } from '../services/constants.service';

@Injectable({
  providedIn: 'root'
})
export class OmsServiceService {

  constructor(
    private http: HttpClient,
    public constantsService: ConstantsService,
  ) { }


  private baseUrl = environment.baseUrl;
  private prescriptionUrl = environment.prescriptionUrl;
  private otpUrl = environment.otpUrl;
  private paymentDifferenceUrl = environment.baseUrl;
  private confirmationOrderUrl = environment.baseUrl;
  private baseUrlDate = environment.baseUrlDate;
  private dynamicUrlDate = environment.dynamicUrlDate;
  private sessionValidationUrl = environment.sessionValidationUrl;
  private reScheduleOrderUrl = environment.baseUrl;
  private userInfoUrl = environment.userInfoUrl;
  private tokenUrl = environment.tokenUrl;
  private changeStatusBasedOnPrescriptionUrl = environment.baseUrl;
  private cancelOrderUrl = environment.baseUrl;
  private rejectOrderUrl = environment.baseUrl;
  private uploadFileUrl = environment.uploadFileUrl;
  private uploadPrescriptionUrl = environment.uploadPrescriptionUrl;
  private cancelationTypeUrl = environment.cancelationTypeUrl;
  private reAllocationUrl = environment.baseUrl;
  private getTestNameApi = environment.testNameApiUrl;
  private addItemAPiUrl = environment.baseUrl;
  private deleteItemApiUrl = environment.baseUrl;
  private reAssignItemApi = environment.reAssignItemApi;
  private getLineItemUrl = environment.getLineItmDetailsUrl;
  private clearSessionUrl = environment.clearSessionUrl;
  private changeStatusUrl = environment.baseUrl;
  private diagnosticCenterApiUrl=environment.diagnosticCenterApiUrl;
  private externalOtpVerifyApiUrl=environment.externalOtpVerifyApiUrl;
  private cancelReasonUrl= environment.cancelReasonUrl;
  private downloadFileUrl= environment.baseUrl;
  private orderTrackApiUrl= environment.baseUrl;
  private deletePrescriptionUrl= environment.baseUrl;
  private labTimingApiUrl= environment.baseUrl;
  private vendorListUrl=environment.baseUrl;
  private assignVendorUrl=environment.baseUrl;
  private getDoctorsApi = environment.getDoctors;
  private updateDoctorsApi = environment.updateDoctor;
  private getDocumentApi = environment.getDocumentUrl;
  private downloadDoc = environment.downloadDoc;
  private invoiceDownload = environment.invoiceDownload;
  private getAssociates = environment.baseUrl;
  private getOfficers = environment.baseUrl;
  private orderAllocation = environment.baseUrl;
  private refundOrders = environment.baseUrl;
  private receiptBill = environment.baseUrl;  
  private refundInfo = environment.baseUrl;
  private rejectRefund = environment.baseUrl;
  private getCategorySubCataegory = environment.baseUrl;
  private escalationCancelOrderUrl = environment.baseUrl;
  private instantRefund = environment.baseUrl;
  private getfetchBusinesses = environment.baseUrl;
  private getTenantAllList = environment.baseUrl;
  private pullTenatOrganisationList = environment.baseUrl;
  private processingSampleSubmission = environment.sampleSubmission;
  private sentFinalReport = environment.baseUrl;


  getOrderDetails(orderRequest): Observable<object> {
    //console.log("getOrderDetails");


    return this.http.post(environment.baseUrl, orderRequest);
  }

  getReimbursementData(reimbursementRequest): Observable<object> {
    return this.http.post(environment.getReimburseDataByTenantOrg, reimbursementRequest);
  }

  getReimburseDetails(reimbursementRequest): Observable<object> {
    return this.http.post(environment.viewReimburse, reimbursementRequest);
  }

  getReimburseStatusList(reimbursementRequest): Observable<object> {
    return this.http.post(environment.reimburseStatusList, reimbursementRequest);
  }

  updateReimburseStatus(reimbursementRequest): Observable<object> {
    return this.http.post(environment.reimburseStatusUpdate, reimbursementRequest);
  }

  getUserDetails(): Observable<object> {
    let httpHeaders = new HttpHeaders({
      'x-session-key': '_chz_id'
    });
    let options = {
      headers: httpHeaders
    };
    return this.http.post(`${this.sessionValidationUrl}`, options);
  }

  getTestNameDetails(orderRequest): Observable<object> {

    return this.http.post(`${this.getTestNameApi}`, orderRequest);
  }

  addItem(addItemRequest): Observable<object> {

    return this.http.post(`${this.addItemAPiUrl}`, addItemRequest);
  }

  deleteItem(deleteItemRequest): Observable<object> {

    return this.http.post(`${this.deleteItemApiUrl}`, deleteItemRequest);
  }

  sendPrescriptionUrl(orderRequest): Observable<object> {

    return this.http.post(`${this.prescriptionUrl}`, orderRequest);
  }

  sendOtp(orderRequest): Observable<object> {
    return this.http.post(`${this.otpUrl}`, orderRequest);
  }

  paymentDifference(orderRequest): Observable<object> {
    return this.http.post(`${this.paymentDifferenceUrl}`, orderRequest);
  }

  orderConfirmation(orderRequest): Observable<object> {
    return this.http.post(`${this.confirmationOrderUrl}`, orderRequest)
  }

  getOrderDate(orderRequest): Observable<object> {

    return this.http.post(`${this.baseUrlDate}`, orderRequest)
  }
  getOrderDynamicDate(orderDateRequest): Observable<object> {

    return this.http.post(`${this.dynamicUrlDate}`, orderDateRequest)
  }
  reAssignItems(reassignItemRequest): Observable<object> {

    return this.http.post(`${this.reAssignItemApi}`, reassignItemRequest);
  }
  getdoctorslist(getdoctorListRequest): Observable<object> {

    return this.http.post(`${this.getDoctorsApi}`, getdoctorListRequest);
  }

  reAssignItemsFormSubmit(reassignFormRequest): Observable<object> {

    return this.http.post(`${this.reAllocationUrl}`, reassignFormRequest);
  }
  reAssignDoctorFormSubmit(reassignFormRequest): Observable<object> {

    return this.http.post(`${this.updateDoctorsApi}`, reassignFormRequest);
  }
  reScheduleOrder(reScheduleOrderRequest): Observable<object> {
    return this.http.post(`${this.reScheduleOrderUrl}`, reScheduleOrderRequest)
  }
  getUserInfo(userInfo): Observable<object> {
    return this.http.post(`${this.userInfoUrl}`, userInfo)
  }

  getUserDateBasedOnToken(token): Observable<object> {



    // const headers = { 'x-session-key': '08+Y84nLwgtSibMRIdQnTOsphmqz7xcfnVj+9j6kv5E='};
    const headers = { 'x-session-key': token };
    const body = {};
    return this.http.post(`${this.tokenUrl}`, body, { headers });
  }

  changeStatusBasedOnPrescription(userInfo): Observable<object> {
    return this.http.post(`${this.changeStatusBasedOnPrescriptionUrl}`, userInfo);
  }

  orderCancel(cancelOrderReq): Observable<object> {
    return this.http.post(`${this.cancelOrderUrl}`, cancelOrderReq);
  }
  orderReject(rejectOrderReq): Observable<object> {
    return this.http.post(`${this.rejectOrderUrl}`, rejectOrderReq);
  }
  uploadFile(formData) {
    return this.http.post<any>(this.uploadFileUrl, formData);
  }
  changeStatusBasedOnReportUpload(formData) {
    return this.http.post<any>(this.changeStatusUrl, formData);
  }

  getCancelTypes(request) {
    //return this.http.get(this.cancelationTypeUrl);
    return this.http.post<any>(this.cancelReasonUrl, request);
  }

  getDocumentUrl(request) {
    // console.log(this.getDocumentApi+request.doc_id)
    let getdocumentID = this.getDocumentApi+request.doc_id;
    return this.http.get(getdocumentID);
  }

  getLineItemDetails(lineItemRequest) {
    return this.http.post<any>(this.reAssignItemApi, lineItemRequest);
  }

  clearUserSession(formData)
  {

    return this.http.post<any>(this.clearSessionUrl, formData);
  }

  orderComplete(completeOrderReq): Observable<object> {
    return this.http.post(`${this.changeStatusUrl}`, completeOrderReq);
  }
  uploadPrescriptionFile(formData) {
    return this.http.post<any>(this.uploadPrescriptionUrl, formData);
  }

  //diagnosticCenterApiUrl : 'https://peqa.callhealth.com/api/searchPatnersByBusiness',

  getDiagnosticData(request) {
    return this.http.post<any>(this.diagnosticCenterApiUrl, request);
  }
  // externalOtpVerify(request) {

  //   let httpHeaders = new HttpHeaders({
  //     'clientId': 'RG9jdG9yUmVkZHknc0NsaWVudA=='
  //   });
  //   let options = {
  //     headers: httpHeaders
  //   };
  //   const body = request;
  //   return this.http.post(this.externalOtpVerifyApiUrl,body, options);
  //   //return this.http.post<any>(this.externalOtpVerifyApiUrl, request);
  // }
  externalOtpVerify(request) {

    
   
    //return this.http.post(this.externalOtpVerifyApiUrl,body, options);
    return this.http.post<any>(this.externalOtpVerifyApiUrl, request);
  }

  downloadFile(request) {
    return this.http.post<any>(this.downloadFileUrl, request);
  }

  resendFinalReport(request) {
    return this.http.post<any>(this.sentFinalReport, request);
  }

  downloadInvoiceFile(request){
    let invoiceID = this.invoiceDownload+request.order_id;
    return this.http.get(invoiceID);
  }

  getOrderTrackData(request) {
    return this.http.post<any>(this.orderTrackApiUrl, request);
  }

  getReceiptOrderData(request) {
    return this.http.post<any>(this.receiptBill, request);
  }

  updateRefundOrder(request) {
    return this.http.post<any>(this.refundInfo, request);
  }

  instantRefundOrder(request) {
    return this.http.post<any>(this.instantRefund, request);
  }

  rejectRefundOrder(request) {
    return this.http.post<any>(this.rejectRefund, request);
  }

  deletePrescription(request) {
    return this.http.post<any>(this.deletePrescriptionUrl, request);
  }

  getLabTimings(request) {
    return this.http.post<any>(this.labTimingApiUrl, request);
  }

  getVendorList(request) {
    return this.http.post<any>(this.vendorListUrl, request);
  }

  getNearbyAssociates(request) {
    return this.http.post<any>(this.getAssociates, request);
  }

  getNearbyOfficers(request) {
    return this.http.post<any>(this.getOfficers, request);
  }

  forceAllocation(request) {
    return this.http.post<any>(this.orderAllocation, request);
  }

  refundOrdersList(request) {
    return this.http.post<any>(this.refundOrders, request);
  }

  assignVendor(request) {
    return this.http.post<any>(this.assignVendorUrl, request);
  }

  private tenantOrgInfo = new BehaviorSubject<string>('');
  tenantOrgInfo$ = this.tenantOrgInfo.asObservable();

  setTenantOrgInfo(data) {
    console.log("set tenants data",data)
    this.tenantOrgInfo.next(data); 
  }

   getDownloadDoc(request){
    let getdocumentID = this.downloadDoc+request.doc_id;
    return this.http.get(getdocumentID);
  }


  getTenantOrgInfo() {
    return this.tenantOrgInfo$;
  }

  getRefundCategorySubCataegory(requestData){
    return this.http.post(this.getCategorySubCataegory, requestData);
  }

  fetchBusiness(businessReq){
    console.log(`this getfetchBusinesses`,this.getfetchBusinesses)
    // let businessReq = {};
    return this.http.post(this.getfetchBusinesses,businessReq);
  }

  escalationOrderCancel(cancelOrderReq): Observable<object> {
    return this.http.post(`${this.escalationCancelOrderUrl}`, cancelOrderReq);
  }

  getTenantList(businessReq){
    // let businessReq = {};
    return this.http.post(this.getTenantAllList,businessReq);
  }

  getTenatOrganisationList(request) {
    return this.http.post<any>(this.pullTenatOrganisationList, request);
  }

  processingSubmission(sampleRequest): Observable<object> {
    return this.http.post(`${this.processingSampleSubmission}`, sampleRequest)
  }

  getTenantOrgList(){
    let payload={
      "type": "GET",
      "method": "/gcm/master/organizationMappings",
      "application": "gcm"
  }
    return this.http.post(`${environment.busUrl}/gcm/api`,payload)

  }

  searchCustomers(payload:any){
    return this.http.post(`${environment.busUrl}/opd/getCustomerDependentsByMobile`,payload)
  }

  getCustomerDetails(payload:any){
    return this.http.post(`${environment.busUrl}/gcm/getCustomerProfile`,payload)
  }
  addAddress(payload:any){
    return this.http.post(`${environment.busUrl}/gcm/addCustomerAddress`,payload)
  }
  customerRegistration(payload:any)
{
  return this.http.post(`${environment.busUrl}/gcm/customerRegistration`,payload)
}
omsCommonMethod(payload:any){
  return this.http.post(`${environment.busUrl}/oms/api`,payload)

}
languagesList(payload:any){
  return this.http.post(`${environment.busUrl}/mdm/languages`,payload)
}
getAssociatesList(payload:any){
  return this.http.post(`${environment.busUrl}/associatePortal/searchAssociates`,payload)
}
associatePortalCommonApi(data:any){
  let payload={
    "method": "services/ispList",
    "type": "POST",
    "application": "AP",
    "request": {
        ...data  
    }
  }
  return this.http.post(`${environment.busUrl}/associatePortal/api`, payload);
}
uploadDocument(fileData:any) {
  let tenant = "1000001"
  fileData.append('tenant', tenant);
   return this.http.post(`${environment.busUrl}/uploadUtils/uploadFile`, fileData)
  
}
mdmCommonMethod(payload:any){
  return this.http.post(`${environment.busUrl}/mdm/api`,payload)

}
processOrder(payload:any){
  return this.http.post(`${environment.busUrl}/oms/processOrder`,payload)

}
downloadReports(payload){
  return this.http.post(`${environment.busUrl}/uploadUtils/downloadLink`,payload)
}
saveEHRdocuments(payload){
  return this.http.post(`${environment.busUrl}/doctor/saveDocument`,payload)
}

// getForceAllocationOffList(payload){
//   return this.http.post(`https://associate-uat.callhealth.com/services/ispList`,payload)
// }
assessmentFormSubmit(payload){
  let data = {
    "method": "clinics/saveFormData",
    "type": "POST",
    "application": "doctor",
    "request": {
      ...payload
    }}
  return this.http.post(`${environment.busUrl}/api`,data)
}

}
